import React from "react";
import "./TicketTypeCard.scss";

const TicketTypeCard: React.FC = ({ tickets }: any) => {
  const incidentTickets = Number(tickets.incident_ticket_count);
  const serviceRequestTickets = Number(tickets.service_ticket_count);
  const totalTickets = Number(incidentTickets + serviceRequestTickets);
  // Percentages
  const incidentPercentage = (incidentTickets / totalTickets) * 100;
  const serviceRequestPercentage = (serviceRequestTickets / totalTickets) * 100;

  return (
    <div className="ticket-type-card  p-6 bg-[#A9CFD6]">
      <div className="ticket-type-header">
        <h3 className="ticket-title mb-2">Ticket type</h3>
        <p className="ticket-subtitle">Overview of ticket type</p>
      </div>

      <div className="ticket-total">
        <span className="ticket-total-number">{totalTickets}</span>
        <span className="ticket-total-label">Tickets</span>
      </div>

      <div className="ticket-progress">
        <div
          className="progress-bar incident h-full"
          style={{ width: `${incidentPercentage}%` }}
        />
        <div
          className="progress-bar service"
          style={{ width: `${serviceRequestPercentage}%` }}
        />
      </div>

      <div className="ticket-breakdown">
        <div className="ticket-item">
          <span className="ticket-label">Incident</span>
          <span className="ticket-value">{incidentTickets}</span>
        </div>
        <div className="ticket-item">
          <span className="ticket-label">Service request</span>
          <span className="ticket-value">{serviceRequestTickets}</span>
        </div>
      </div>
    </div>
  );
};

export default TicketTypeCard;
